"use client";

import CallingIcon from "@/helpers/svg/callingIcon.svg";
import ContactUsIcon from "@/helpers/svg/contactUsIcon.svg";
import FileConfirmIcon from "@/helpers/svg/fileConfirmIcon.svg";
import InstagramIcon from "@/helpers/svg/instagramIcon.svg";
import TelegramIcon from "@/helpers/svg/telegramIcon.svg";
import VectorContactUs from "@/helpers/svg/vectorContactUs.svg";
import WebpageIcon from "@/helpers/svg/webpageIcon.svg";
import WhatsappContact from "@/helpers/svg/whatsappContact.svg";
import { Input } from "@nextui-org/react";
import { Textarea } from "@nextui-org/react";
import XIcon from "@/helpers/svg/xIcon.svg";
import React from "react";
import CustomButton from "@/components/common/button";
import SendMessage from "@/helpers/svg/sendMessage.svg";
import { useMediaQuery } from "@mui/material";
import AboutUsVector from "@/helpers/svg/aboutUsVector.svg";
const ContactUs = () => {
  const desktop = useMediaQuery("(min-width:1024px)");

  return (
    <>
      {desktop ? (
        <div className="flex flex-col px-12 py-24 min-h-[100vh] h-auto w-full md:py-28 md:px-28">
          <div className="flex flex-col md:flex-row justify-between">
            <div className="flex flex-col text-primary-white">
              <h2 className="text-3xl font-semibold	py-2">
                تماس با مـــنـــه‌بــاخ
              </h2>
              <VectorContactUs />
              <span className="text-xl">
                از طریق راه‌های زیر با ما در ارتباط باشید
              </span>
            </div>
            <div>
              <ContactUsIcon />
            </div>
          </div>
          <div className="flex flex-col lg:flex-row justify-between items-center px-8 md:px-14">
            <div className="flex flex-col justify-between ml-4 items-between w-[90%]">
              <div className="flex flex-col justify-center items-center text-primary-white w-full text-xl mb-12 pt-12">
                <span>شبکه‌های اجتماعی</span>
                <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                  <div className="flex justify-center items-center my-2">
                    <a className="cursor-pointer ml-2">
                      <TelegramIcon />
                    </a>
                    <a className="cursor-pointer ml-2">
                      <WhatsappContact />
                    </a>
                    <a className="cursor-pointer ml-2">
                      <XIcon />
                    </a>
                    <a className="cursor-pointer ml-2">
                      <InstagramIcon />
                    </a>
                    <a className="cursor-pointer ml-2">
                      <FileConfirmIcon />
                    </a>
                  </div>
                </div>
              </div>
              <div className="flex flex-col justify-center items-center text-primary-white w-full text-xl cursor-pointer mb-12">
                <span>تماس</span>
                <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                  <span className="ml-2">۰۲۱-۲۶۲۱۲۶۸۲</span>
                  <CallingIcon />
                </div>
              </div>
              <div className="flex flex-col justify-center items-center text-primary-white w-full text-xl cursor-pointer">
                <span>صندوق پستی</span>
                <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                  <span className="ml-2">ad@manabakh.ir</span>
                  <WebpageIcon />
                </div>
              </div>
            </div>
            <div className="flex flex-col w-full gr-border mr-4 bg-[#000000]">
              <div className="flex pt-4">
                <Input
                  className="input-button ml-4"
                  type="firstname"
                  label="نام"
                />
                <Input
                  className="input-button"
                  type="firstname"
                  label="نام‌خانوادگی"
                />
              </div>
              <div className="pt-4">
                <Input
                  className="input-button"
                  type="firstname"
                  label="صندوق پستی"
                />
              </div>
              <div className="pt-4 w-full">
                <Textarea
                  label="توضیحات"
                  className="input-button w-full"
                  minRows={8}
                />
              </div>
              <div className="py-4">
                <CustomButton
                  color="primary"
                  label="ارسال پیام"
                  width="100%"
                  textColor="text-primary-white"
                  rightIcon={<SendMessage />}
                  fullWidth={true}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col pt-24 w-full px-7 md:px-20 lg:px-24 min-h-[100vh] h-auto">
          <div className="flex flex-col justify-center items-center w-full mb-16">
            <div className="flex flex-col justify-center items-center text-[#D9D9D9]">
              <span className="text-3xl font-medium mb-5">تـــمـــاس با</span>
              <span className="text-4xl font-bold">مــنـه‌بـاخ</span>
            </div>
            <div className="mb-1 mt-8 flex w-full justify-center items-center">
              <AboutUsVector />
            </div>
            <div className="flex justify-around flex-wrap sm:flex-nowrap items-center w-full text-[#BFBFBF] font-bold text-xs sm:text-[14px]">
              <span>از طریق راه‌های زیر با ما در ارتباط باشید</span>
            </div>
          </div>
          <div className="flex flex-col justify-between ml-4 items-between w-full px-16 sm:px-36">
            <div className="flex flex-col justify-center items-center text-primary-white w-full text-xl mb-6">
              <span>شبکه‌های اجتماعی</span>
              <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                <div className="flex justify-center items-center my-2">
                  <a className="cursor-pointer ml-2">
                    <TelegramIcon />
                  </a>
                  <a className="cursor-pointer ml-2">
                    <WhatsappContact />
                  </a>
                  <a className="cursor-pointer ml-2">
                    <XIcon />
                  </a>
                  <a className="cursor-pointer ml-2">
                    <InstagramIcon />
                  </a>
                  <a className="cursor-pointer ml-2">
                    <FileConfirmIcon />
                  </a>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-center items-center text-primary-white w-full text-xl cursor-pointer mb-6">
              <span>تماس</span>
              <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                <span className="ml-2">۰۲۱-۲۶۲۱۲۶۸۲</span>
                <CallingIcon />
              </div>
            </div>
            <div className="flex flex-col justify-center items-center text-primary-white w-full text-xl cursor-pointer mb-6">
              <span>واتس اپ</span>
              <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                <span className="ml-2">09352126666</span>
                <WhatsappContact />
              </div>
            </div>
            <div className="flex flex-col justify-center items-center text-primary-white w-full text-xl cursor-pointer mb-4">
              <span>صندوق پستی</span>
              <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                <span className="ml-2">ad@manabakh.ir</span>
                <WebpageIcon />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ContactUs;
